export default "__VITE_ASSET__BPFUoYY1__"